import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  footer: {
    flexShrink: 0,
    padding: "7px 12px",
    paddingBottom: "max(7px, env(safe-area-inset-bottom))",
    textAlign: "center",
    background: theme.app.tint,
    fontSize: 10,
    color: theme.palette.text.secondary,
    "& strong": { fontWeight: 700 },
  },
}));
export default function BrandFooter({ light = false }) {
  const classes = useStyles();
  return <footer className={classes.footer} style={light ? { color: "#61756b" } : undefined}>Desenvolvido por <strong>PixelCraft</strong></footer>;
}

